import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'superflex-cancelar-btn',
    template: `
        <p-button
            label="{{'BOTONES.btnCancelar' | translate}}"
            [icon]="icon"
            [styleClass]="styleClass"
            [class]="class"
            (onClick)="onClick.emit()" [disabled]="isDisabled">
        </p-button>`,
})
export class CancelarBtnComponent {
    @Input() isDisabled: boolean;
    @Input() icon = '';
    @Output() onClick = new EventEmitter<any>();
    @Input() styleClass = 'p-button-outlined p-mr-2';
    @Input() class = '';

    constructor() {/***/}
}
